export const colorPairs = [
  { text: "text-blue-500", bg: "bg-blue-200", bd: "border-blue-500" },
  { text: "text-green-500", bg: "bg-green-200", bd: "border-green-500" },
  { text: "text-purple-500", bg: "bg-purple-200", bd: "border-purple-500" },
  { text: "text-red-500", bg: "bg-red-200", bd: "border-red-500" },
  { text: "text-yellow-500", bg: "bg-yellow-200", bd: "border-yellow-500" },
];

export const formatDate = (date: string): string => {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(new Date(date));
};





export const ServiceLogo = (serviceName: string): string => {
  return `/assets/images/services/${serviceName.toLowerCase().replace(/\s+/g, '_')}.png`;
};

export const formatAmount = (amount: any, defaultValue: string = "N/A") =>
  amount != null && !isNaN(amount) ? amount : defaultValue;



